import React from 'react'
import cx from 'classnames'

import s from './Section.scss'


const Section = ({ children, className }) => (
  <div className={cx(s.slide, className)}>
    {children}
  </div>
)

export default Section
